<p-message severity="warn">
    ⚠️&nbsp;Please select tool to initiate deeplinking.
</p-message>
<p-message severity="error" class="m-2">
    🚨&nbsp;Please deeplink with only one course from the tool.
</p-message>
<p-fieldset legend="Select Tool" class="m-2">
    <p class="m-0">
                    <p-table selectionMode="single" 
                    [value]="tools" size="small" 
                    [loading]="loading()" stripedRows 
                    showGridlines [paginator]="true"  
                    [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10]" 
                    [(selection)]="selectedTool" 
                    dataKey="clientId"
                    [lazy]="true" [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="name" style="width:11%">
                                    Name <p-sortIcon field="name"/>
                                </th>
                                <th style="width:11%">ClientId</th>
                                <th style="width:11%">Active</th>
                                <th style="width:11%">Supports Deeplinking</th>
                                <th style="width:11%">Grade Service</th>
                                <th style="width:11%">NRPS Service</th>
                                <th style="width:11%" pTooltip="Sharing learner email with 3rd Party Tool" tooltipPosition="top">Sharing Learner Email</th>
                                <th style="width:11%" pTooltip="Sharing learner full name with 3rd Party Tool" tooltipPosition="top">Sharing Learner Full Name</th>
                                <th style="width:11%">&nbsp;</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-tool>
                            <tr [pSelectableRow]="tool">
                                <td>{{ tool.name }}</td>
                                <td>{{ tool.clientId }}</td>
                                <td>
                                    @if (tool.isActive) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.supportsDeepLinking) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isAssignmentAndGradeServiceEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isNamesAndRoleProvisioningServiceEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isSharingFullNameOfLearnerWithToolEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td>
                                    @if (tool.isSharingEmailOfLearnerWithToolEnabled) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td><!-- TODO: Put a nice button here then open deeplinking interface.coz at this point you have courseCode and tool also need to consider the tool.supportsDeepLinking, maybe show button only if it supports deeplinking -->
                                     @if (tool.supportsDeepLinking) {
                                        <p-button label="Deeplink Course" severity="contrast" (click)="initiateDeeplinking(tool.id)" />
                                     } @else {
                                       <i>No Deeplinking Support</i>
                                    }
                                    
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
</p-fieldset>

        